import { render, staticRenderFns } from "./region-child-add.vue?vue&type=template&id=68a7b96f&scoped=true&"
import script from "./region-child-add.vue?vue&type=script&lang=js&"
export * from "./region-child-add.vue?vue&type=script&lang=js&"
import style0 from "./region-child-add.vue?vue&type=style&index=0&id=68a7b96f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a7b96f",
  null
  
)

export default component.exports